/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import {BootstrapVue} from "bootstrap-vue";

window.Vue = require('vue');

import VueRouter from 'vue-router'
import VueScrollTo from 'vue-scrollto'
import i18n from './i18n'
import router from './router'
import store from './store'
import Embed from 'v-video-embed'
import App from './App.vue'
import Vue2TouchEvents from "vue2-touch-events";

Vue.use(VueRouter);
Vue.use(Embed);
Vue.use(VueScrollTo);
Vue.use(BootstrapVue);
Vue.use(Vue2TouchEvents, {
    disableClick: false,
    touchClass: '',
    tapTolerance: 10,
    touchHoldTolerance: 400,
    swipeTolerance: 30,
    longTapTimeInterval: 400,
    namespace: 'touch'
});

const app = new Vue({
    el: '#app',
    store: store,
    router: router,
    i18n,
    render: h => h(App)
});
